/**
 * Sanitize admin position inputs: digits only, no leading zeros / no 0.
 * Empty string is allowed while the user is clearing the field.
 */
export function sanitizePositionInput(value) {
  const digits = String(value ?? "").replace(/[^\d]/g, "");
  // Strip leading zeros so "0", "00", "01" → "", "", "1"
  return digits.replace(/^0+/, "");
}

/**
 * Parse a 1-based position for submit. Returns null when unset / invalid / 0.
 */
export function parsePositivePosition(value) {
  const parsed = parseInt(value, 10);
  return Number.isInteger(parsed) && parsed >= 1 ? parsed : null;
}
